import { styled } from '@linaria/react';
import { fonts, semantic, size, space } from '../../theme/tokens';

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  gap: ${space['space-200']};
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};

  &[data-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Input = styled.input`
  appearance: none;
  box-sizing: border-box;
  width: ${size.icon['icon-md']};
  height: ${size.icon['icon-md']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.secondary};
  border-radius: ${size.radius['radius-full']};
  margin: 0;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;

  &:checked {
    border-color: ${semantic.border.selected};
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: ${space['space-100']};
    left: ${space['space-100']};
    width: 14px;
    height: 14px;
    border-radius: ${size.radius['radius-full']};
    background: ${semantic.bg.primary};
  }

  &[data-error='true'],
  &[data-error='true']:checked {
    border-color: ${semantic.border.danger};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
